import { Skeleton } from '@crehana/compass.ui/skeleton';

type TSummaryCardVariant = 'default' | 'success' | 'alert';

type TSummaryCardProps = {
  label: string;
  value: string;
  subtitle: string;
  variant?: TSummaryCardVariant;
};

const VALUE_COLOR_MAP: Record<TSummaryCardVariant, string> = {
  default: 'tw-cds-text-primary',
  success: 'tw-cds-text-success',
  alert: 'tw-cds-text-alert',
};

export const SummaryCard = ({
  label,
  value,
  subtitle,
  variant = 'default',
}: TSummaryCardProps) => {
  return (
    <div
      className="tw-cds-bg-primary tw-cds-rounded-m tw-flex tw-flex-col tw-gap-0.4 tw-py-2 tw-px-2.4"
      style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}
    >
      <span className="tw-cds-font-label-01 tw-cds-text-subtle tw-uppercase">
        {label}
      </span>
      <span className={`tw-cds-font-heading-02 ${VALUE_COLOR_MAP[variant]}`}>
        {value}
      </span>
      <span className="tw-cds-font-body-01 tw-cds-text-subtle">{subtitle}</span>
    </div>
  );
};

export const SummaryCardSkeleton = () => {
  return (
    <div
      className="tw-cds-bg-primary tw-cds-rounded-m tw-flex tw-flex-col tw-gap-0.8 tw-py-2 tw-px-2.4"
      style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}
    >
      <Skeleton className="tw-w-16 tw-h-1.6 tw-rounded" />
      <Skeleton className="tw-w-12 tw-h-3.2 tw-rounded" />
      <Skeleton className="tw-w-20 tw-h-1.6 tw-rounded" />
    </div>
  );
};
